var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":"Processing...","active":_vm.active},on:{"close":function($event){return _vm.$emit('cancel')}}},[(_vm.message)?_c('h4',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('div',{staticClass:"alert-message"},[_c('div',{staticClass:"loader"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }